@if (data(); as data) {
  <div class="flex flex-col rounded-md bg-gray-50 p-16">
    <div class="mb-6 text-3xl font-bold text-gray-600">
      @if (shouldShowPayForTheRecurringOrder()) {
        Ustaw płatność cykliczną – to już prawie koniec!
      }

      @if (shouldShowPayForTheOrder()) {
        Opłać zamówienie - to już prawie koniec!
      }
    </div>

    <app-alerts />

    <div class="flex flex-col flex-wrap gap-6 text-sm text-gray-500">
      <div>
        <div class="flex flex-wrap">
          <span class="mr-1">Status zamówienia:</span>
          <span class="font-bold">
            {{ data.status | orderStatus | async }}
          </span>
        </div>

        <div class="flex flex-wrap">
          <span class="mr-1">Numer zamówienia:</span>
          <span class="font-bold">{{ data.number }}</span>
        </div>

        <div class="flex flex-wrap">
          <span class="mr-1">Całkowita wartość zamówienia:</span>
          <span class="font-bold">
            <app-currency [amount]="data.totalPrice" />
          </span>
        </div>

        <div class="flex flex-wrap">
          <span class="mr-1">Rodzaj płatności:</span>
          <span class="font-bold">
            {{ data.paymentMethod.name }}
          </span>
        </div>
      </div>

      @if (shouldShowPayForTheRecurringOrder()) {
        <div>
          <div>
            Twoje zamówienie zawiera produkty wymagające konfiguracji płatności
            cyklicznej.
          </div>

          <div class="mt-6">
            <app-public-checkout-recurrence-payment
              (tokenizeSuccessEvent)="handleTokenizeClick($event)" />
          </div>
        </div>
      }

      @if (shouldShowPaymentMethodDescription()) {
        <app-summernote-html-preview [html]="data.paymentMethod.description" />
      }

      @if (
        shouldShowPayForTheOrder() && !shouldShowPaymentMethodDescription()
      ) {
        <div>
          <div class="flex flex-wrap">
            O kolejnych etapach będziemy niezwłocznie powiadamiać Cię drogą
            mailową.
          </div>

          <div>
            @if (redirect()) {
              Jeśli jeszcze nie dokonano płatności, kliknij poniższy przycisk
              lub zaczekaj na przekierowanie.
            } @else {
              Jeśli jeszcze nie dokonano płatności, kliknij poniższy przycisk.
            }
          </div>
        </div>

        <div class="text-base">
          <app-slim-button
            (clickEvent)="handlePaymentClick()"
            maxWidth="16rem"
            label="Opłać zamówienie ({{ seconds() }} sek)"
            theme="primary" />
        </div>
      }
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
